/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
  ClientCredentialRegisterResponse,
  ClientCredentialRegisterResponseFromJSON,
  ClientCredentialRegisterResponseToJSON,
  HTTPValidationError,
  HTTPValidationErrorFromJSON,
  HTTPValidationErrorToJSON,
} from '../models';

export interface RegisterAsOauth2ClientClientCredentialsRegisterPostRequest {
  acceptLanguage?: string;
}

export interface RenewClientCredentialsClientCredentialsRenewPostRequest {
  acceptLanguage?: string;
}

/**
 *
 */
export class ClientCredentialsApi extends runtime.BaseAPI {
  /**
   * This endpoint is used to register a channel as an OAuth2.0 client.  An Exception Error will be raised in the following cases: - If the user doesn\'t have an active channel. - If the user channel already has a client credential.  It has the following query parameter: - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English)
   * Register As Oauth2 Client
   */
  async registerAsOauth2ClientClientCredentialsRegisterPostRaw(
    requestParameters: RegisterAsOauth2ClientClientCredentialsRegisterPostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<ClientCredentialRegisterResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/client_credentials/register`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ClientCredentialRegisterResponseFromJSON(jsonValue)
    );
  }

  /**
   * This endpoint is used to register a channel as an OAuth2.0 client.  An Exception Error will be raised in the following cases: - If the user doesn\'t have an active channel. - If the user channel already has a client credential.  It has the following query parameter: - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English)
   * Register As Oauth2 Client
   */
  async registerAsOauth2ClientClientCredentialsRegisterPost(
    requestParameters: RegisterAsOauth2ClientClientCredentialsRegisterPostRequest,
    initOverrides?: RequestInit
  ): Promise<ClientCredentialRegisterResponse> {
    const response =
      await this.registerAsOauth2ClientClientCredentialsRegisterPostRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }

  /**
   * This endpoint is used to generate a new client credentials of the channel and revoke the old one if exists.  An Exception Error will be raised in the following cases: - **HTTP_404_NOT_FOUND**: If the user doesn\'t have a channel. - **HTTP_401_UNAUTHORIZED**: If the channel is not OAuth2.0 client.
   * Renew Client Credentials
   */
  async renewClientCredentialsClientCredentialsRenewPostRaw(
    requestParameters: RenewClientCredentialsClientCredentialsRenewPostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<ClientCredentialRegisterResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/client_credentials/renew`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ClientCredentialRegisterResponseFromJSON(jsonValue)
    );
  }

  /**
   * This endpoint is used to generate a new client credentials of the channel and revoke the old one if exists.  An Exception Error will be raised in the following cases: - **HTTP_404_NOT_FOUND**: If the user doesn\'t have a channel. - **HTTP_401_UNAUTHORIZED**: If the channel is not OAuth2.0 client.
   * Renew Client Credentials
   */
  async renewClientCredentialsClientCredentialsRenewPost(
    requestParameters: RenewClientCredentialsClientCredentialsRenewPostRequest,
    initOverrides?: RequestInit
  ): Promise<ClientCredentialRegisterResponse> {
    const response =
      await this.renewClientCredentialsClientCredentialsRenewPostRaw(
        requestParameters,
        initOverrides
      );
    return await response.value();
  }
}
